import script from "./NewIncomingWebRtcCall.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewIncomingWebRtcCall.vue?vue&type=script&setup=true&lang=ts"

import "./NewIncomingWebRtcCall.vue?vue&type=style&index=0&id=6fa9f85c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa9f85c"]])

export default __exports__